export const roleFilter = user => {
  return ({ role }) => {
    return !role || role === (user.projectEmployeeIsMentor ? "mentor" : "employee");
  };
};
